import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { validCachedFinalPrice } from "./presentation-text";
import type { VerifiedDisplayPrice } from "./presentation-text";

/** Read only: same final-quote rows written by the existing sync. No Bókun calls or writes. */
export const getPresentationPrices = createServerFn({ method: "GET" })
  .inputValidator(z.object({ ids: z.array(z.string().regex(/^\d{1,12}$/)).max(200) }))
  .handler(async ({ data }): Promise<Record<string, VerifiedDisplayPrice | null>> => {
    const { publicReadClient } = await import("./public-read.server");
    if (!data.ids.length) return {};
    const { data: rows, error } = await publicReadClient().from("tour_card_cache").select("product_id,price").in("product_id", data.ids);
    if (error) return {};
    return Object.fromEntries((rows ?? []).map(r => [String(r.product_id), validCachedFinalPrice(r.price)]));
  });